import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import Applicants from './pages/Applicants';
import NewLeads from './pages/NewLeads';
import Admin from './pages/Admin';
import Jobs from './pages/Jobs';
import ApplicantProfile from './pages/ApplicantProfile';
import Settings from './pages/Settings';
import NewLeadsConfigure from './pages/NewLeadsConfigure';
import DBSchema from './pages/DBSchema';
import Feedback from './pages/Feedback';
import FeedbackManagement from './components/FeedbackManagement';
import ActivityLog from './pages/ActivityLog';
import Team from './pages/Team';
import Reports from './pages/Reports';
import Layout from './components/Layout';
import EmailSettings from './pages/EmailSettings';
import EmailTemplates from './pages/EmailTemplates';
import TelegramBotSettings from './pages/TelegramBotSettings';

const DashboardRouter = () => {
  const { user } = useAuth();
  return user?.isSuperAdmin ? <SuperAdminDashboard /> : <Dashboard />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <DashboardRouter />
              </PrivateRoute>
            }
          />
          <Route
            path="/applicants"
            element={
              <PrivateRoute>
                <Applicants />
              </PrivateRoute>
            }
          />
          <Route
            path="/applicants/:id"
            element={
              <PrivateRoute>
                <ApplicantProfile />
              </PrivateRoute>
            }
          />
          <Route
            path="/new-leads"
            element={
              <PrivateRoute requiredPermission={{ resource: 'new_leads_page', action: 'read' }}>
                <NewLeads />
              </PrivateRoute>
            }
          />
          <Route
            path="/jobs"
            element={
              <PrivateRoute>
                <Jobs />
              </PrivateRoute>
            }
          />
          <Route
            path="/team"
            element={
              <PrivateRoute>
                <Team />
              </PrivateRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <PrivateRoute requiredPermission={{ resource: 'applicant', action: 'read' }}>
                <Reports />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute requireSuperAdmin>
                <Admin />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <Settings />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings/newleadsconfigure"
            element={
              <PrivateRoute requireSuperAdmin>
                <NewLeadsConfigure />
              </PrivateRoute>
            }
          />
          <Route
            path="/db-schema"
            element={
              <PrivateRoute requireSuperAdmin>
                <DBSchema />
              </PrivateRoute>
            }
          />
          <Route
            path="/feedback"
            element={
              <PrivateRoute>
                <Feedback />
              </PrivateRoute>
            }
          />
          <Route
            path="/activity"
            element={
              <PrivateRoute requireSuperAdmin>
                <ActivityLog />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings/email"
            element={
              <PrivateRoute requireSuperAdmin>
                <EmailSettings />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings/telegram-bot"
            element={
              <PrivateRoute requireSuperAdmin>
                <TelegramBotSettings />
              </PrivateRoute>
            }
          />
          <Route
            path="/email-templates"
            element={
              <PrivateRoute requireSuperAdmin>
                <EmailTemplates />
              </PrivateRoute>
            }
          />
          <Route
            path="/feedback/manage"
            element={
              <PrivateRoute requireSuperAdmin>
                <Layout><FeedbackManagement /></Layout>
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
